import React from 'react';
import io from 'socket.io-client';

const { REACT_APP_SOCKET_PORT,REACT_APP_SOCKET_URL } = process.env;

const url = new URL(REACT_APP_SOCKET_URL);

export const socket = io.connect(`wss://${url.hostname}:${REACT_APP_SOCKET_PORT}`,{secure:true});
export const SocketContext = React.createContext();